<template>
    <div>
        <config-main-title>Certificado Digital</config-main-title>

        <p>Prezado(o) {{ $store.state.user.search }},</p>

        <p>
            Carregar Certificado Digital tipo A1. O certificado A1 é um arquivo com extensão PFX.<br>
            Você não deve fornecer sua senha do certificado para terceiros. Ela é a sua segurança no momento da assinatura de documentos.
            Ela será usada apenas para validar o certificado durante seu carregamento e para assinar documentos.
        </p>

        <hr>

        <template v-if="!item">

            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>

        </template>

        <template v-else>

            <small class="form-text text-muted text-nowrap text-truncate">
                Senha do Certificado
            </small>

            <div class="row">
                <div class="col col-12 col-md-4">
                    <input 
                        type="text" 
                        id="password" 
                        style="-webkit-text-security: disc;" 
                        v-model="chave" 
                        autocomplete="off"
                        class="form form-control" />
                </div>
                <div class="col col-12 col-md-8 d-flex" v-if="chave">
                    <az-single-image-loader 
                        chave="pfx"
                        :titulo="item.tem_certificado ? 'Atualizar Certificado' : 'Carregar Certificado'" 
                        :single="true" 
                        :parms="{ model_type: 'medico', model_id: item.id_pessoa, cadastro_medico: true, tipo_especial: 'certificado', certificado_chave: chave }" 
                        extension="pfx"
                        mimetype="application/x-pkcs12"
                        service="medicos"
                        :blockcam="true"
                        @refresh="pos_upload()" />

                    <button class="btn btn-outline-primary mb-2" @click="verificarCertificado()" :disabled="$store.state.loading">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="$store.state.loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        <i class="fas fa-user-check mr-2" v-else></i>
                        Verificar certificado
                    </button>

                    
                </div>
            </div>

            <template v-if="dados_certificado">
                <pre class="alert alert-info mt-3">{{ dados_certificado }}</pre>
            </template>

            <hr>

            <ul class="list-group mt-3" v-if="item.tem_certificado">
                <li class="list-group-item">
                    <i class="fas fa-signature fa-2x fa-fw mr-3"></i>
                    Figura que representa que o documento pode ser assinado.
                </li>
                <li class="list-group-item">
                    <i class="fas fa-file-contract fa-2x fa-fw mr-3"></i>
                    Figura que representa que o documento está assinado.
                </li>
            </ul>

        </template>
    </div>
</template>

<script>
import * as moment from 'moment';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzSingleImageLoader from '../../../util/AzSingleImageLoader.vue';

export default {
    data () { 
        return { 
            chave: "",
            item: null, 
            dados_certificado: null,
        }
    },

    components: { 
        ConfigMainTitle,
        AzSingleImageLoader,
    },

    methods: { 
        pos_upload() { 
            this.load();

            if ( this.item && this.item.tem_certificado ) { 
                this.verificarCertificado();
            }
        },

        verificarCertificado () { 

            this.dados_certificado = "";

            this.$store.commit("loading", true);

            this.$util.loadItem(this, { 
                service: 'medicos',
                func: 'dados_certificado',
                parms: { 
                    chave: this.chave,
                }
            })
            .then(res => { 
                this.dados_certificado = res;

                if ( res.validTo ) { 
                    this.dados_certificado.validade = moment(res.validTo, 'YYMMDDHHmmssZ').format('YYYY-MM-DD');
                }
            })
            .finally(() => { 
                this.$store.commit("loading", false);
            });

        },

        load() { 
            this.$util.loadItem(this, { 
                service: 'medicos', 
                parms: { 
                    id: this.$store.state.user.id_pessoa,
                    cadastro_medico: true, 
                }
            })
            .then(item => { 
                this.item = item;
            });          
        }
    },

    mounted() { 
        this.load();

        this.breadcrumb = [
            { name: "Certificado Digital", path: "/certificado"},
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    }
}
</script>